import React from "react";
import "../styles/tailwind.css";
import Brands from "../components/Brands";
import Testimonials from "../components/Testimonials";
import AboutUs from "../components/AboutUs";
import Hero from "../components/Hero";

const HomePage = () => {
  return (
    <div>
      {/* Hero Section */}
      <Hero />

      {/* Car Brand Carousel */}
      <Brands />

      {/* Featured Products Section */}

      {/* About Us */}
      <AboutUs />

      {/* Testimonials Section */}
      <Testimonials />
    </div>
  );
};

export default HomePage;
